import FormField from "../form-field";
import CheckboxesInput from "../inputs/checkboxes-input";

export default class CheckboxesField extends FormField {
	constructor(props) {
		super(props);

		this.checkboxesInput = null;
		this.altDataType = props.altDataType == null ? false : true;

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('CheckboxesField: Root element is not defined!');
		}

		this.checkboxesInput = new CheckboxesInput({
			$root: this.$root.querySelector('[data-input="checkboxes"]'),
			altDataType: this.altDataType
		});

		super.init();
	}

	addEventListeners() {
		this.checkboxesInput.subscribe('valueChange', this.handleValueChange.bind(this));
	}

	handleValueChange(e) {
		this.setValue(e.detail);
		this.validateSoft();
	}

	validate() {
		if (this.altDataType) {
			this.isValid = Object.values(this.value).some((value) => value === true);
		} else {
			this.isValid = this.value !== null;
		}
	}

	setInitialState() {
		this.checkboxesInput.uncheckAll();
	}

	setInitialValue(value) {
		this.bulkCheckOptions(value);
	}

	checkOption(value) {
		this.checkboxesInput.checkOption(value);
	}

	bulkCheckOptions(values) {
		let valuesToCheck = values;

		if (typeof valuesToCheck === 'object' && this.altDataType) {
			valuesToCheck = Object.keys(valuesToCheck).filter((value) => !!valuesToCheck[value]);
		} else if (!Array.isArray(values)) {
			return;
		}

		valuesToCheck.forEach((value) => {
			this.checkOption(value);
		})
	}
}